import { render, staticRenderFns } from "./ReturnTransportSettings.vue?vue&type=template&id=78a97972"
import script from "./ReturnTransportSettings.vue?vue&type=script&lang=ts"
export * from "./ReturnTransportSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports